import { css } from 'lit';

export default css`
  #sharpen-container-size {
    background-color: #fff;
  }

  .sharpen-product-img-border {
    border: 1px solid rgba(0, 0, 0, 0.13);
  }

  .sharpen-product-img {
    align-self: center;
    width: auto;
    min-width: 120px;
  }

  #net-price {
    color: var(--Body-Text-Body-Color, var(--Body-Text-Body-Color, #222));
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 27px */
  }

  #sharpen-title {
    color: var(--Components-Button-Link-Link, #006bd6);
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 21.6px */
  }

  #upsell-container {
    background-color: #d9e5fc;
    padding: 24px 32px;
  }

  #container-title {
    color: var(--Body-Text-Body-Color, #222);
    /* Components/Navs & Tabs/Header */
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 27px */
  }

  #isbn-block-info {
    color: var(--Body-Text-Body-Color, var(--Body-Text-Body-Color, #222));
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 21px */
  }

  @media (min-width: 768px) {
    .upsell-card-width {
      width: 640px;
    }
  }
`;
